define(["exports", "react", "./CvProviderContext"], function (_exports, _react, _CvProviderContext) {
  "use strict";

  var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.CvProvider = CvProvider;
  _react = _interopRequireWildcard(_react);

  function CvProvider(_ref) {
    var children = _ref.children;

    var _useState = (0, _react.useState)(false),
        readMoreFromPrint = _useState[0],
        setReadMoreFromPrint = _useState[1];

    var _useState2 = (0, _react.useState)(false),
        shouldHideButtonOnPrint = _useState2[0],
        setShouldHideButtonOnPrint = _useState2[1];

    (0, _react.useLayoutEffect)(function () {
      if (readMoreFromPrint && shouldHideButtonOnPrint) {
        window.print();
        setReadMoreFromPrint(false);
        setShouldHideButtonOnPrint(false);
      }
    }, [readMoreFromPrint, shouldHideButtonOnPrint]);

    var handlePrintCv = function handlePrintCv() {
      setReadMoreFromPrint(true);
      setShouldHideButtonOnPrint(true);
    };

    return /*#__PURE__*/_react.default.createElement(_CvProviderContext.CvProviderContext.Provider, {
      value: {
        handlePrintCv: handlePrintCv,
        setShouldHideButtonOnPrint: setShouldHideButtonOnPrint,
        shouldHideButtonOnPrint: shouldHideButtonOnPrint,
        setReadMoreFromPrint: setReadMoreFromPrint,
        readMoreFromPrint: readMoreFromPrint
      }
    }, children);
  }
});